import {
	AfterContentChecked,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
} from "@angular/core";
import { AbstractControl, UntypedFormArray, UntypedFormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatTabGroup } from "@angular/material/tabs";
import { isNil } from "lodash";
import { NgxIndexedDBService } from "ngx-indexed-db";
import { CONSTANT } from "src/app/constant";
import { AssessmentEvaludationReq, DraftItem, OBComments, OBCommentsReq, ResetOB } from "src/app/models/models";
import { CbtaModalComponent } from "src/app/shared/components/cbta-modal/cbta-modal.component";
import { DraftService } from "src/app/shared/services/draft.service";
import { HttpService } from "src/app/shared/services/http.service";
import { LoaderService } from "src/app/shared/services/loader.service";
import { SharedService } from "src/app/shared/services/shared.service";

@Component({
	selector: "app-add-maneuver",
	templateUrl: "./add-maneuver.component.html",
	styleUrls: ["./add-maneuver.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class AddManeuverComponent implements OnInit, AfterContentChecked {
	maneuverForm!: UntypedFormGroup;
	parentForm!: UntypedFormArray;
	parentFormArrayIndex: number = 0;
	panelOpenState: boolean = false;
	currentSliderValue: number = 0;
	loadingCount: number = 0;
	resetRepeat: number = 0;
	@Input() isManeuverVisible = true;
	@Input() isSafetyOutcomeVisible = false;
	@Input() tabIndex!: MatTabGroup;
	@Input() obComments!: Array<OBComments>;
	@Input("maneuverForm") set _(value: any) {
		this.maneuverForm = value as UntypedFormGroup;
	}
	@Output() selectedOBList: EventEmitter<any> = new EventEmitter<any>();
	@Output() resetCurrentManeuver: EventEmitter<any> = new EventEmitter<any>();
	TS1_OB_LIST: Array<any> = [];
	tempFrom: any = {};
	hasValueList: any = [];
	newOBList: any = []; // OB's added on rating

	constructor(
		public sharedService: SharedService,
		private dialog: MatDialog,
		private httpService: HttpService,
		private loadingService: LoaderService,
		private cd: ChangeDetectorRef,
		private dbService: NgxIndexedDBService,
		private draftService: DraftService,
	) {}

	ngOnInit(): void {
		this.parentForm = this.maneuverForm.parent as UntypedFormArray;
		this.parentFormArrayIndex = this.parentForm.controls.findIndex((subform) => subform == this.maneuverForm);

		// generate all OB from master data
		this.TS1_OB_LIST = this.sharedService.generateSortedOBList();

		this.selectedOBs?.valueChanges.subscribe((val) => {
			if (val) {
				const isArray = Array.isArray(val);
				if (!isArray) {
					this.selectedOBList.emit(val);
				} else {
					for (const v of val) {
						this.selectedOBList.emit(v);
					}
				}
			}
		});
	}

	get inDraftMode(): boolean {
		return this.draftService.inDraftMode;
	}

	ngAfterContentChecked(): void {
		// check if the form is being updated outside this component and loaded atleast, if yes take a duplicate and reset to this
		if (this.maneuverForm.touched && this.loadingCount == 1) {
			this.tempFrom = Object.assign({}, this.maneuverForm.value);

			if (this.safetyOutcome?.value == -2) {
				this.maneuverForm.setErrors({ invalid: true });
			}

			this.TS1_OB_LIST.forEach((ob: any, index: number) => {
				this.hasValueList[index] = this.hasValue(ob.title);
			});
			this.cd.detectChanges();
		}
		this.loadingCount++;
	}

	hasValue(key: string): boolean {
		const codeValues = this.maneuverForm.value[key];
		for (const k in codeValues) {
			if (codeValues[k] === true) {
				return true;
			}
		}
		return false;
	}

	isRemoved(key: string, index: number, fc: AbstractControl) {
		const selectedOBs = this.selectedOBs?.value ?? [];
		let moreAddedOb = [];
		for (const s of selectedOBs) {
			const ob = s.ob;
			const action = s.action;

			if (action) {
				const newOB = {} as any;
				newOB[ob] = !action;
				moreAddedOb.push(newOB);
			}
		}

		const newlyAddedOB = [...this.newOBList, ...moreAddedOb].map((v: any) => Object.keys(v)).flat();

		let newLyAddedFiltered = newlyAddedOB;

		for (const ob of selectedOBs) {
			if (ob.action && ob.isRepeat === false) {
				newLyAddedFiltered.push(ob.ob);
			}
		}

		if (!isNil(this.tempFrom[key]) && this.tempFrom[key][`${key}${index}`] == true) {
			return this.tempFrom[key][`${key}${index}`] == true && fc.get(`${key}${index}`)?.value == false;
		} else {
			return newlyAddedOB.includes(`${key}${index}`) && fc.get(`${key}${index}`)?.value == false;
		}
	}

	isAdded(key: string, index: number, fc: AbstractControl) {
		return (
			!isNil(this.tempFrom[key]) &&
			this.tempFrom[key][`${key}${index}`] == false &&
			fc.get(`${key}${index}`)?.value == true
		);
	}

	temCommentsModal(data: AssessmentEvaludationReq): void {
		let remarks = data.rate === 0 ? "Incomplete" : data.rate === -1 ? "N/A" : `Rating ${data.rate}`;

		const dialogRef = this.dialog.open(CbtaModalComponent, {
			panelClass: "tem-comments-modal",
			height: "560px",
			width: "840px",
			hasBackdrop: true,
			data: {
				modalName: "temCommentsModal",
				modalTitle: "Remarks",
				modalBtnConfirmText: "Save",
				modalBtnCancelText: "Cancel",
				disableClose: true,
				temComment: {
					rating: data.rate,
					remarks: remarks,
					maneuver: this.maneuver.value,
				},
			},
		});

		const sub = dialogRef.afterClosed().subscribe((result: any) => {
			if (result && result.close) {
				const remakrs = result?.comment ?? "";
				if (data.rate != -2) {
					console.log("temCommentsModal online : ", navigator.onLine);

					const selectedOB: OBComments = {
						maneuver:
							this.repeat?.value != 0 ? `R${this.repeat?.value} ${this.maneuver.value}` : `${this.maneuver.value}`,
						ob: "TEM",
						action: true,
						remarks: remarks,
						instructorComment: remakrs.toUpperCase(),
						rate: data.rate,
						isDisabled: false,
					};

					if (!navigator.onLine || this.inDraftMode) {
						this.safetyOutcome?.patchValue(data.rate);

						this.dbService.getByID<DraftItem>(CONSTANT.INDEXEDDB.DRAFT, this.traineeAssessmentId.value).subscribe(
							(record) => {
								const candidateRating = record?.candidateRating ?? {};

								const temEvaluations = candidateRating?.temEvaluations ?? [];
								const temRate = candidateRating?.temRate ?? {};
								const selectedOBs = candidateRating?.selectedOBs ?? [];

								selectedOBs.push({
									...selectedOB,
									candidateId: this.candidateId.value,
								});

								temEvaluations.push({
									assessmentId: this.assessmentId.value,
									candidateId: this.candidateId.value,
									data,
									remarks: remakrs.toUpperCase(),
								});

								this.dbService
									.update(CONSTANT.INDEXEDDB.DRAFT, {
										...record,
										candidateRating: {
											...candidateRating,
											temEvaluations,
											selectedOBs,
											temRate: {
												...temRate,
												[`${this.candidateId.value}.${this.assessmentId.value}`]: {
													assessmentId: this.assessmentId.value,
													rate: data.rate,
												},
											},
										},
										lastUpdatedDate: new Date().toISOString(),
										continuePage: 2,
									})
									.subscribe(
										(result) => {
											console.log("rating updated", result);
											this.draftService.addToBeSynched("tem_score", {
												assessmentId: this.assessmentId.value,
												candidateId: this.candidateId.value,
												rate: data.rate,
												remarks: remakrs.toUpperCase(),
											});
											this.selectedOBList.emit(selectedOB);
										},
										(error) => {
											console.error(error);
										},
									);
							},
							(error) => {
								console.error(error);
							},
						);
					} else {
						this.loadingService.setLoading(true);
						this.httpService
							.assessmentEvaluation(this.candidateId.value, {
								...data,
								remarks: remakrs.toUpperCase(),
							})
							.subscribe(
								(resp: any) => {
									this.safetyOutcome?.patchValue(data.rate);
									this.selectedOBList.emit(selectedOB);

									// todo update selectedOBs, temEvaluations, temRate
									const candidateRating = this.draftService.tempDraft?.candidateRating;
									// const toBeSynced = this.draftService.tempDraft?.toBeSynced ?? [];

									const temEvaluations = candidateRating?.temEvaluations ?? [];
									const temRate = candidateRating?.temRate ?? {};
									const selectedOBs = candidateRating?.selectedOBs ?? [];

									selectedOBs.push({
										...selectedOB,
										candidateId: this.candidateId.value,
									});

									temEvaluations.push({
										assessmentId: this.assessmentId.value,
										candidateId: this.candidateId.value,
										data,
										remarks: remakrs.toUpperCase(),
									});

									// toBeSynced.push({
									//   eventName: 'tem_score',
									//   body: {
									//     assessmentId: this.assessmentId.value,
									//     candidateId: this.candidateId.value,
									//     rate: data.rate,
									//     remarks: remakrs.toUpperCase(),
									//   }
									// });

									this.draftService.tempDraft = {
										candidateRating: {
											...candidateRating,
											temEvaluations,
											selectedOBs,
											temRate: {
												...temRate,
												[`${this.candidateId.value}.${this.assessmentId.value}`]: {
													assessmentId: this.assessmentId.value,
													rate: data.rate,
												},
											},
										},
										// toBeSynced
									};

									this.loadingService.setLoading(false);
								},
								(err) => {
									console.error(`Assessment evaluation failed!`, err);
									this.loadingService.setLoading(false);
								},
							);
					}
				} else {
					this.maneuverForm.setErrors({ invalid: true });
				}
			} else {
				this.safetyOutcome?.patchValue(undefined);
				this.safetyOutcome?.setValue(undefined);
			}
			sub.unsubscribe();
		});
	}

	onRatingChange(value: any) {
		const data = {
			remarks: "",
			rate: value,
			assessmentId: this.assessmentId.value,
		} as AssessmentEvaludationReq;

		data.remarks = data.rate === 0 ? "Incomplete" : data.rate === -1 ? "N/A" : `Rating ${data.rate}`;

		if ([-1, 0, 1, 5].includes(value)) {
			this.temCommentsModal(data);
		} else {
			if (value == -2) {
				this.safetyOutcome?.patchValue(data.rate);
				this.maneuverForm.setErrors({ invalid: true });
				this.parentForm.updateValueAndValidity();
			} else {
				console.log("onRatingChange online : ", navigator.onLine);
				if (!navigator.onLine || this.inDraftMode) {
					console.log("onRatingChange  : ", {
						candidate: this.candidateId.value,
						data,
					});
					this.safetyOutcome?.patchValue(data.rate);

					this.dbService.getByID<DraftItem>(CONSTANT.INDEXEDDB.DRAFT, this.traineeAssessmentId.value).subscribe(
						(record) => {
							const candidateRating = record?.candidateRating ?? {};
							const temEvaluations = candidateRating?.temEvaluations ?? [];
							const temRate = candidateRating?.temRate ?? {};

							temEvaluations.push({
								assessmentId: this.assessmentId.value,
								candidateId: this.candidateId.value,
								data,
								remarks: data.remarks,
							});

							this.dbService
								.update(CONSTANT.INDEXEDDB.DRAFT, {
									...record,
									candidateRating: {
										...candidateRating,
										temEvaluations,
										temRate: {
											...temRate,
											[`${this.candidateId.value}.${this.assessmentId.value}`]: {
												assessmentId: this.assessmentId.value,
												rate: data.rate,
											},
										},
									},
									lastUpdatedDate: new Date().toISOString(),
									continuePage: 2,
								})
								.subscribe(
									(result) => {
										console.log("rating updated", result);
										this.draftService.addToBeSynched("tem_score", {
											assessmentId: this.assessmentId.value,
											candidateId: this.candidateId.value,
											rate: data.rate,
											remarks: data.remarks,
										});
									},
									(error) => {
										console.error(error);
									},
								);
						},
						(error) => {
							console.error(error);
						},
					);
				} else {
					this.loadingService.setLoading(true);
					this.httpService.assessmentEvaluation(this.candidateId.value, data).subscribe(
						(resp: any) => {
							this.safetyOutcome?.patchValue(data.rate);

							// todo update temRate of tempDraft
							const candidateRating = this.draftService.tempDraft?.candidateRating;
							// const toBeSynced = this.draftService.tempDraft?.toBeSynced ?? [];
							const temEvaluations = candidateRating?.temEvaluations ?? [];
							const temRate = candidateRating?.temRate ?? {};

							temEvaluations.push({
								assessmentId: this.assessmentId.value,
								candidateId: this.candidateId.value,
								data,
								remarks: data.remarks,
							});

							// toBeSynced.push({
							//   eventName: 'tem_score',
							//   body:  {
							//     assessmentId: this.assessmentId.value,
							//     candidateId: this.candidateId.value,
							//     rate: data.rate,
							//     remarks: '',
							//   }
							// });

							this.draftService.tempDraft = {
								candidateRating: {
									...candidateRating,
									temEvaluations,
									temRate: {
										...temRate,
										[`${this.candidateId.value}.${this.assessmentId.value}`]: {
											assessmentId: this.assessmentId.value,
											rate: data.rate,
										},
									},
								},
								// toBeSynced
							};

							this.loadingService.setLoading(false);
						},
						(err) => {
							console.error(`Assessment evaluation failed!`, err);
							this.loadingService.setLoading(false);
						},
					);
				}
			}
		}
	}

	get maneuver() {
		return this.maneuverForm.get("maneuver")!;
	}
	get maneuverCode() {
		return this.maneuverForm.get("maneuverCode")!;
	}

	get assessmentId() {
		return this.maneuverForm.get("assessmentId")!;
	}

	get selectedOBs() {
		return this.maneuverForm.get("selectedOBs")!;
	}

	get traineeAssessmentId() {
		return this.maneuverForm.get("traineeAssessmentId")!;
	}

	get candidateId() {
		return this.maneuverForm.get("candidateId")!;
	}

	get PRO(): UntypedFormGroup {
		return this.maneuverForm.controls["PRO"] as UntypedFormGroup;
	}

	get COM(): UntypedFormGroup {
		return this.maneuverForm.controls["COM"] as UntypedFormGroup;
	}

	get LTW(): UntypedFormGroup {
		return this.maneuverForm.controls["LTW"] as UntypedFormGroup;
	}

	get PSD(): UntypedFormGroup {
		return this.maneuverForm.controls["PSD"] as UntypedFormGroup;
	}

	get FPA(): UntypedFormGroup {
		return this.maneuverForm.controls["FPA"] as UntypedFormGroup;
	}

	get FPM(): UntypedFormGroup {
		return this.maneuverForm.controls["FPM"] as UntypedFormGroup;
	}

	get SAW(): UntypedFormGroup {
		return this.maneuverForm.controls["SAW"] as UntypedFormGroup;
	}

	get WLM(): UntypedFormGroup {
		return this.maneuverForm.controls["WLM"] as UntypedFormGroup;
	}

	get KNO(): UntypedFormGroup {
		return this.maneuverForm.controls["KNO"] as UntypedFormGroup;
	}

	get safetyOutcome() {
		return this.maneuverForm.get("safetyOutcome");
	}

	get repeat() {
		return this.maneuverForm.get("repeat");
	}

	saveManeuver(value: string): void {
		this.maneuver.patchValue(value);
	}

	savePRO(value: boolean): void {
		// control?.patchValue(!value);
	}

	onCheckBoxClick(control: AbstractControl | null, ob: string): void {
		if (this.isSafetyOutcomeVisible) {
			this.obCommentsModel(ob, control);
		} else {
			const obname = ob.slice(0, 3);
			control?.patchValue(!control?.value);
		}
	}

	reaptConfirmModal(): void {
		const dialogRef = this.dialog.open(CbtaModalComponent, {
			panelClass: "logout-modal",
			height: "200px",
			width: "360px",
			hasBackdrop: true,
			data: {
				modalTitle: "Confirm repeat action!",
				modalContent: "Are you sure to reset this Maneuver to default selection?",
				modalBtnConfirmText: "Yes",
				modalBtnCancelText: "No",
			},
		});

		const sub = dialogRef.afterClosed().subscribe((result: any) => {
			if (result && result.close) {
				this.saveAndClear();
			}
			sub.unsubscribe();
		});
	}

	obCommentsModel(ob: string, action: AbstractControl | null): void {
		const dialogRef = this.dialog.open(CbtaModalComponent, {
			panelClass: "ob-comments-modal",
			height: "560px",
			width: "840px",
			hasBackdrop: true,
			data: {
				modalName: "obCommentsModel",
				modalTitle: "Summary",
				modalContent: this.obComments,
				modalBtnConfirmText: "Save",
				modalBtnCancelText: "Cancel",
				disableClose: true,
				newComment: {
					maneuver: this.maneuver.value,
					ob: ob,
					action: !action?.value,
				},
			},
		});

		const sub = dialogRef.afterClosed().subscribe((result: any) => {
			if (result && result.comment) {
				const obAction = {
					maneuver:
						this.repeat?.value != 0 ? `R${this.repeat?.value} ${this.maneuver.value}` : `${this.maneuver.value}`,
					ob: ob,
					action: !action?.value,
					instructorComment: result.comment.toUpperCase(),
				} as OBComments;

				let formattedOB = ob.toLocaleLowerCase();

				const obActionReq = {
					candidateId: this.candidateId.value,
					observationCode: `${formattedOB.slice(0, 3)}_${formattedOB.slice(3, 4)}`,
					maneuverCode: this.maneuverCode.value,
					isRemoved: action?.value,
					description: result.comment.toUpperCase(),
				} as OBCommentsReq;

				console.log("addRemoveRatingObservation isOnline : ", navigator.onLine);

			if (!navigator.onLine || this.inDraftMode) {
				console.log("addRemoveRatingObservation : ", {
					traineeAssessmentId: this.traineeAssessmentId.value,
					obActionReq,
				});
				action?.patchValue(!action?.value);
				this.selectedOBList.emit(obAction);
				if (action?.value) {
					const newOB = {} as any;
					newOB[ob] = !action?.value;
					this.newOBList.push(newOB);
				}

				this.dbService.getByID<DraftItem>(CONSTANT.INDEXEDDB.DRAFT, this.traineeAssessmentId.value).subscribe(
						(record) => {
							const candidateRating = record?.candidateRating ?? {};

							const addRemoveOb = candidateRating?.addRemoveOb ?? [];
							const selectedOBs = candidateRating?.selectedOBs ?? [];

							selectedOBs.push({
								...obAction,
								candidateId: this.candidateId.value,
							});

							addRemoveOb.push({
								...obActionReq,
								candidateId: this.candidateId.value,
							});

							this.dbService
								.update(CONSTANT.INDEXEDDB.DRAFT, {
									...record,
									candidateRating: {
										...candidateRating,
										addRemoveOb,
										selectedOBs,
									},
									lastUpdatedDate: new Date().toISOString(),
									continuePage: 2,
								})
								.subscribe(
									(result) => {
										console.log("rating updated", result);

										this.draftService.addToBeSynched("observation", obActionReq);
									},
									(error) => {
										console.error(error);
									},
								);
						},
						(error) => {
							console.error(error);
						},
					);
				} else {
					this.loadingService.setLoading(true);
					console.log("addRemoveRatingObservation : ", obActionReq);
					this.httpService
						.addRemoveRatingObservation(this.traineeAssessmentId.value, obActionReq)
						.subscribe((resp: any) => {
							action?.patchValue(!action?.value);
							this.selectedOBList.emit(obAction);
							this.loadingService.setLoading(false);
							if (action?.value) {
								const newOB = {} as any;
								newOB[ob] = !action?.value;
								this.newOBList.push(newOB);
							}

							// to do add obAction on tempdraft
							const candidateRating = this.draftService.tempDraft?.candidateRating;

							const addRemoveOb = candidateRating?.addRemoveOb ?? [];
							const selectedOBs = candidateRating?.selectedOBs ?? [];
							// const toBeSynced = this.draftService.tempDraft?.toBeSynced ?? [];

							selectedOBs.push({
								...obAction,
								candidateId: this.candidateId.value,
							});

							addRemoveOb.push({
								...obActionReq,
								candidateId: this.candidateId.value,
							});

							// toBeSynced.push({
							//   eventName: 'observation',
							//   body: obActionReq,
							// });

							this.draftService.tempDraft = {
								candidateRating: {
									...candidateRating,
									addRemoveOb,
									selectedOBs,
								},
								// toBeSynced
							};
						});
				}
			}
			sub.unsubscribe();
		});
	}

	saveAndClear() {
		const data = {
			candidateId: this.candidateId.value,
			comment: "",
		} as ResetOB;

		console.log("repeat isonline : ", navigator.onLine);
		if (!navigator.onLine || this.inDraftMode) {
			console.log("saveAndClear : ", {
				traineeAssessmentId: this.traineeAssessmentId.value,
				maneuverCode: this.maneuverCode.value,
				data,
			});
			this.newOBList = [];
			this.maneuverForm.setValue(this.tempFrom);
			this.cd.detectChanges();
			// count the repeat and update the form value for `repeat`
			this.resetRepeat++;
			this.repeat?.patchValue(this.resetRepeat);

			this.dbService.getByID<DraftItem>(CONSTANT.INDEXEDDB.DRAFT, this.traineeAssessmentId.value).subscribe(
				(record) => {
					const candidateRating = record?.candidateRating ?? {};

					const resetManeuvers = candidateRating?.resetManeuvers ?? [];

					const addRemoveObs = candidateRating?.addRemoveOb ?? [];
					const selectedOBs = candidateRating?.selectedOBs ?? [];

					const filteredAddRemoveObs = addRemoveObs.map((a) => {
						if (a.candidateId === this.candidateId.value && a.maneuverCode === this.maneuverCode.value) {
							return {
								...a,
								isRepeat: true,
							};
						} else {
							return a;
						}
					});

					const options = this.sharedService.dropDownOptionsManeuver;

					const filteredSelectedOBs = selectedOBs.map((a) => {
						const maneuver = options.find((e) => a.maneuver.includes(e.description));

						if (a.candidateId === this.candidateId.value && maneuver?.code === this.maneuverCode.value) {
							return {
								...a,
								isRepeat: true,
							};
						} else {
							return a;
						}
					});

					const temRate = candidateRating?.temRate ?? {};

					if (this.candidateId.value && this.assessmentId.value) {
						delete temRate[`${this.candidateId.value}.${this.assessmentId.value}`];
					}

					resetManeuvers.push({
						traineeAssessmentId: this.traineeAssessmentId.value,
						maneuverCode: this.maneuverCode.value,
						candidateId: this.candidateId.value,
						comment: "",
						count: this.resetRepeat,
						createdAt: new Date().toISOString(),
					});

					this.dbService
						.update(CONSTANT.INDEXEDDB.DRAFT, {
							...record,
							candidateRating: {
								...candidateRating,
								resetManeuvers,
								temRate,
								addRemoveOb: filteredAddRemoveObs,
								selectedOBs: filteredSelectedOBs,
							},
							lastUpdatedDate: new Date().toISOString(),
							continuePage: 2,
						})
						.subscribe(
							(result) => {
								console.log("rating updated", result);
								this.draftService.addToBeSynched("repeat_evaluation", {
									candidateId: this.candidateId.value,
									comment: "",
									code: this.maneuverCode.value,
								});
							},
							(error) => {
								console.error(error);
							},
						);
				},
				(error) => {
					console.error(error);
				},
			);
		} else {
			this.loadingService.setLoading(true);

			this.httpService.resetOB(this.traineeAssessmentId.value, this.maneuverCode.value, data).subscribe(
				(resp: any) => {
					// this.tempFrom = Object.assign({}, this.maneuverForm.value);
					this.newOBList = [];
					this.maneuverForm.reset();
					this.maneuverForm.setValue(this.tempFrom);
					this.cd.detectChanges();
					// count the repeat and update the form value for `repeat`
					this.resetRepeat++;
					this.repeat?.patchValue(this.resetRepeat);
					// this.resetCurrentManeuver.emit({ form: this.maneuverForm, value: m });

					// to do reset for tempDraft
					const candidateRating = this.draftService.tempDraft?.candidateRating;
					// const toBeSynced = this.draftService.tempDraft?.toBeSynced ?? [];

					const resetManeuvers = candidateRating?.resetManeuvers ?? [];

					const addRemoveObs = candidateRating?.addRemoveOb ?? [];

					const filteredAddRemoveObs = addRemoveObs.map((a) => {
						if (a.candidateId === this.candidateId.value && a.maneuverCode === this.maneuverCode.value) {
							return {
								...a,
								isRepeat: true,
							};
						} else {
							return a;
						}
					});

					const temRate = candidateRating?.temRate ?? {};

					if (this.candidateId.value && this.assessmentId.value) {
						delete temRate[`${this.candidateId.value}.${this.assessmentId.value}`];
					}

					resetManeuvers.push({
						traineeAssessmentId: this.traineeAssessmentId.value,
						maneuverCode: this.maneuverCode.value,
						candidateId: this.candidateId.value,
						comment: "",
						count: this.resetRepeat,
						createdAt: new Date().toISOString(),
					});

					// toBeSynced.push({
					//   eventName: 'repeat_evaluation',
					//   body: {
					//     candidateId: this.candidateId.value,
					//     comment: '',
					//     code: this.maneuverCode.value,
					//   },
					// })

					this.draftService.tempDraft = {
						candidateRating: {
							...candidateRating,
							resetManeuvers,
							temRate,
							addRemoveOb: filteredAddRemoveObs,
						},
						// toBeSynced
					};
					this.loadingService.setLoading(false);
				},
				(error) => {
					console.error(error);
					this.loadingService.setLoading(false);
				},
			);
		}
	}

	next() {
		const m = this.maneuver.value;
		this.tabIndex.selectedIndex = m && this.sharedService.dropDownOptionsManeuver.indexOf(m) + 1;
	}

	back() {
		const m = this.maneuver.value;
		this.tabIndex.selectedIndex = m && this.sharedService.dropDownOptionsManeuver.indexOf(m) - 1;
	}
}
